import React, { useEffect, useState } from 'react';
import { Slot } from './Interfaces/SlotType';
import { convertFirstLetterToLowerCase } from '../../../Utils/BaseUtils'

interface SlotInputProps {
    index: number;
    drivers: any[],
    slots: Slot[],
    slot: Slot;
    onUpdateSlot: (updatedSlot: Slot) => void;
    onDeleteSlot: () => void;
}

const SlotInput: React.FC<SlotInputProps> = ({ index, drivers, slots, slot, onUpdateSlot, onDeleteSlot }) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
        let { name, value } = event.target;
        name = convertFirstLetterToLowerCase(name.replace(`Slots[${index}].`, ''));
        let [parentPropName, childPropName] = name.split('.');
        if (childPropName) {
            childPropName = convertFirstLetterToLowerCase(childPropName);
            onUpdateSlot(({
                ...slot,
                [parentPropName]: {
                    [childPropName]: value,
                },
            }));
        } else {
            onUpdateSlot({
                ...slot,
                [name]: value
            });
        }
    };

    return (
        <div className="shadow-box mt-20 mb-20" style={{ position: 'relative' }}>
            <h6 className='mb-10 mt-10'>Slot {index + 1}</h6>
            <a className='delete-item-cross' onClick={onDeleteSlot}>x</a>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label">
                        Index
                    </label>
                    <input
                        className="input-field"
                        readOnly={true}
                        type="text"
                        name={`Slots[${index}].index`}
                        value={slot.index}
                        onChange={handleInputChange}
                    />

                </div>
                <div className="input-box">
                    <label className="input-label">
                        Driver associato
                    </label>
                    <select
                    name={`Slots[${index}].associatedDriverId`}
                    value={slot.associatedDriverId}
                    className='input-select'
                    onChange={handleInputChange}
                    >
                        <option value="null">Seleziona un driver</option>
                        {drivers?.map((el) => {
                            return (
                                <option 
                                value={el.Id}
                                key={`driver-${el.Id}`}
                                >{el.Name}</option>
                            )
                        })}
                    </select>
                </div>
            </div>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label">
                        Diverter
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name={`Slots[${index}].diverter`}
                        value={slot.diverter}
                        onChange={handleInputChange}
                    />

                </div>
                <div className="input-box">
                    <label className="input-label">
                        Parent
                    </label>
                    <select
                    name={`Slots[${index}].parent.index`}
                    value={slot.parent?.index}
                    disabled={slot.index == 1}
                    className='input-select'
                    onChange={handleInputChange}
                    >
                        <option value="null">Seleziona un parent</option>
                        {slots?.map((el) => {
                            {return el !== slot && el.index > 0 ? (
                                <option 
                                value={el.index}
                                key={`parent-${el.index}`}
                                >{`Slot ${el.index}`}</option>
                            ) : null}
                        })}
                    </select>
                </div>
            </div>

            <button type="button" className="mt-20 delete-button" onClick={onDeleteSlot}>
                Cancella Slot
            </button>
        </div>
    );
};

export default SlotInput;